import React from 'react';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import EventPlayButton from './EventPlayButton';

export default (props) => {
  return (
    <Paper style={{marginBottom: "20px", paddingBottom: "15px"}}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={4}>
          <Box p={2} >
            <img src={props.config.imageUrl} alt="" style={{width: "100%", height: "auto"}} />
          </Box>
        </Grid>
        <Grid item xs={8}>
          <div style={{ minHeight: "150px" }}>
            <div><h4 style={{ padding: "20px 20px 0 0", color: "#555" }}>{props.config.time}</h4></div>
            <div><h6 style={{ padding: "5px 20px 5px 0", color: "#555" }}>{props.config.title}</h6></div>
            { props.config.speaker &&
              <div><h6 style={{ padding: "5px 20px 10px 0", color: "#555", fontWeight: "normal" }}><b>Speaker:</b> {props.config.speaker}</h6></div>
            }
            { props.config.facilitator &&
              <div><h6 style={{ padding: "5px 20px 10px 0", color: "#555", fontWeight: "normal" }}><b>Facilitator:</b> {props.config.facilitator}</h6></div>
            }
            {/* { props.config.panelists &&
              <div><b>Panelists:</b> {props.config.panelists}</div>
            } */}
          </div>
          <Grid container direction="row"  justify="space-between" alignItems="center">
            <Grid item>
              <EventPlayButton config={props.config} setVideoSrc={props.setVideoSrc} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
